import { render, staticRenderFns } from "./createBulkPromotion.vue?vue&type=template&id=6159f9f2&scoped=true"
import script from "./createBulkPromotion.vue?vue&type=script&lang=js"
export * from "./createBulkPromotion.vue?vue&type=script&lang=js"
import style0 from "./createBulkPromotion.vue?vue&type=style&index=0&id=6159f9f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6159f9f2",
  null
  
)

export default component.exports